import React from 'react';

import { TranslatedTextMessage } from './TranslatedTextMessage';

const AVRequiredText = () => (
  <p className="age-gate__av-required-text">
    <TranslatedTextMessage id={'AV_REQUIRED'} />
  </p>
);

export default AVRequiredText;
